import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const WashLabelState = Immutable.fromJS({
  washLabel: {
    orderId: '',
    serialNoFrom: 1,
    serialNoTo: 9999,
    template:'template_b',
    outputFile: ''
  },
  washLabelValidation: {
    serialNoFrom: {
      validationState: null,
      helpBlock: null
    },
    serialNoTo: {
      validationState: null,
      helpBlock: null
    },
    template: {
      validationState: null,
      helpBlock: null
    }
  },
  alertStyle: null,
  alertMessage: null
});

const washLabelReducer = handleActions({
  CHANGE_LABEL_ORDERID: (state, { payload }) => {
    let washLabel = state.get('washLabel');
    return state.merge({
      washLabel: washLabel.set('orderId', payload.orderId),
    })
  },
  CHANGE_WASHLABEL_VALUE: (state, { payload }) => {
    let washLabel = state.get('washLabel');
    return state.merge({
      washLabel: washLabel.set(payload.id, payload.value),
    });
  },
  BEFORE_GENERATE_WASHLABEL: (state, { payload }) => {
    return state.merge({
      washLabel: {
        outputFile: ''
      },
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    });
  },
  AFTER_GENERATE_WASHLABEL: (state, { payload }) => {

    // open pdf file automatically
    // if (payload.data.bean.outputFile !== '') {
    //   window.open(payload.data.bean.outputFile);
    // }

    // change state
    return state.merge({
      washLabel: payload.data.bean,
      washLabelValidation: payload.data.valBean,
      alertStyle: payload.data.alertStyle,
      alertMessage: payload.data.alertMessage
    });
  },
  CLEAN_WASHLABEL_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null,
      washLabelValidation: {}
    })
  }
}, WashLabelState);

export default washLabelReducer;


// WEBPACK FOOTER //
// ./src/reducers/washLabelReducer.js